import { render } from "./AssignProductModal.vue?vue&type=template&id=927715f4&ts=true"
import script from "./AssignProductModal.vue?vue&type=script&lang=ts"
export * from "./AssignProductModal.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/kemet/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__